import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPartMakesOverview } from '../../../store/Slices/PartMakeSlice';
import Stats from '../../../components/Stats';
import { activeStatsIcon, lateStatsIcon, tripStatsIcon } from '../../../utils/svgs';

const PartMakeOverviewCards = () => {
    const dispatch = useDispatch();
    const { partMakesOverview, partMakesOverviewLoading } = useSelector((state) => state.partMakes);

    useEffect(() => {
        dispatch(getPartMakesOverview());
    }, [dispatch]);

    const statsData = [
        {
            title: 'Total Part Makes',
            value: partMakesOverview?.total || 0,
            text: 'Total number of part makes',
            icon: tripStatsIcon,
            className: 'total'
        },
        {
            title: 'Active',
            value: partMakesOverview?.active || 0,
            text: 'Active part makes',
            icon: activeStatsIcon,
            className: 'completed'
        },
        {
            title: 'Inactive',
            value: partMakesOverview?.inactive || 0,
            text: 'Inactive part makes',
            icon: lateStatsIcon,
            className: 'late'
        }
    ];

    if (partMakesOverviewLoading && !partMakesOverview) {
        return (
            <div className="stats_main_div skeleton-loader" style={{ height: '100px', marginBottom: '20px' }}>
                {/* Skeleton state */}
            </div>
        );
    }

    return (
        <Stats statsData={statsData} numberOfColumn={4} />
    );
};

export default PartMakeOverviewCards;
